import React from 'react'
import moment from 'moment'
import DatePicker from 'react-datepicker'

import Table from '../TableComponent'
import RoomRow from '../RoomRowComponent'

export default class StepTwoComponent extends React.Component {

    render () {
        let { selectedRoom, startDate} = this.props
        let { dateAvailable, max_booking_time } = selectedRoom

        let minStartDate = dateAvailable === null || (moment().diff(dateAvailable, 'days') > 0) ? moment() : moment(dateAvailable)
        let maxDate = moment(minStartDate).add(max_booking_time, 'days')

        return (
            <div>
                <Table>
                    <tbody>
                        <RoomRow room={selectedRoom} />
                    </tbody>
                </Table>
                <div
                    style={{ display: 'flex', justifyContent: 'center', marginTop: 50 }}
                >
                    <DatePicker
                        selected={startDate}
                        inline
                        onChange={this.props.onChangeDate}
                        monthsShown={1}
                        minDate={minStartDate}
                        maxDate={maxDate}
                        locale="da"
                    />
                </div>
            </div>
        )
    }

}


// WEBPACK FOOTER //
// ./src/components/steps/StepTwoComponent.jsx